/*eslint-disable */

import "jquery"
import "jquery-match-height"
import "jquery-colorbox"
import "jquery.marquee"
import "flexslider"
import "modernizr"
//import "filepicker-js"
import "magnific-popup"

import "bootstrap"

require("./styles")

//filepicker.setKey("AB1KOrj9XSx4Nswl7iZk1z")
//filepicker.setResponsiveOptions({
//  onResize: "all"
//})

/*eslint-enable */

// $(document).ready(function() {
//   console.log('document ready') // eslint-disable-line no-console
//
//
// })



// WEBPACK FOOTER //
// ./assets/js/vendor.js